import BoardList from './BoardList/BoardList';
import { communicationConfig } from './BoardList/boardListConfigs';

const CommunicationList = ({ communications, communicationViews, setCommunications, handleSelectCommunication, userId, userRole }) => (
    <BoardList
        config={communicationConfig}
        items={communications}
        views={communicationViews}
        setItems={setCommunications}
        onEdit={handleSelectCommunication}
        userId={userId}
        userRole={userRole}
    />
);

export default CommunicationList;
